import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { SourceGroupApi } from './models/source-group.api.model';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MultiBaseAbstractApi } from '@api/genericApi/multi-base-abstract.api';


@Injectable()
export class SourceGroupApiService extends MultiBaseAbstractApi<SourceGroupApi, SourceGroupApi> {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<SourceGroupApi[]> {
        const slug: string = '/source-group/all';

        return this.neptuneApi.api<SourceGroupApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    create(source: SourceGroupApi): Observable<number> {
        const slug: string = '/source-group';

        return this.neptuneApi.api<number>(
            slug,
            source,
            HttpVerbsEnum.POST
        );
    }

    deleteByIds(ids: number[]): Observable<null> {
        const slug: string = '/source-group';

        return this.neptuneApi.api<null>(
            slug,
            ids,
            HttpVerbsEnum.DELETE
        );
    }

    update(source: SourceGroupApi): Observable<null> {
        const slug: string = `/source-group/${source.id}`;

        return this.neptuneApi.api<null>(
            slug,
            source,
            HttpVerbsEnum.PUT
        );
    }
}
